import { useEffect, useRef } from 'react'

const usePolling = ({ pollFn, shouldPoll, interval = 5000, withEagerPolling = false }) => {
  const intervalRef = useRef(null)
  const pollFnRef = useRef(pollFn)
  const shouldPollRef = useRef(shouldPoll)

  // Keep refs up to date without triggering useEffect
  pollFnRef.current = pollFn
  shouldPollRef.current = shouldPoll

  useEffect(() => {
    const poll = () => {
      if (shouldPollRef.current()) {
        pollFnRef.current()
      }
      // Don't clear the interval here - let it keep running
    }

    // Fire immediately on mount
    if (withEagerPolling) {
      pollFnRef.current()
    }

    // Then start the interval
    intervalRef.current = setInterval(poll, interval)

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [ interval ])
}
export default usePolling
